module.exports = __webpack_public_path__ + "components/closing-infographics/static/infographic--AT-fc7833d27d3c80d1c45f619e33d09bbd.jpg";